import variables from '@wix/communities-blog-client-common/src/styles/variables.scss';

export const APP_COMPONENT_CLASS_NAME = variables.appComponentClassName.replace(/"/g, '');
